var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46824 7.83352L11.8083 2.49337C11.9319 2.36985 12 2.20498 12 2.02917C12 1.85337 11.9319 1.68849 11.8083 1.56498L11.4151 1.17172C11.1589 0.915818 10.7425 0.915818 10.4867 1.17172L6.00249 5.65597L1.51326 1.16674C1.38965 1.04323 1.22487 0.975037 1.04916 0.975037C0.873261 0.975037 0.708482 1.04323 0.584775 1.16674L0.191706 1.56001C0.0680971 1.68362 1.04147e-08 1.8484 1.25111e-08 2.0242C1.46076e-08 2.2 0.0680971 2.36488 0.191706 2.48839L5.53664 7.83352C5.66064 7.95732 5.8262 8.02532 6.00219 8.02493C6.17888 8.02532 6.34434 7.95732 6.46824 7.83352Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.ac05dcf490f577c3c071deb5876ffe37.svg";
export { ForwardRef as ReactComponent };